import React, { useContext } from 'react';
import { PageIntro } from '@stereoagency/ui';
import { useCallToActions } from '@/hooks';
import { LinesContext } from '@/components/LinesContext';
import { parseHtml } from '@/utils';

type Props = {
  data: {
    style: 'basic'
    label?: string
    title: string
    content?: string
    callToActions?: number[]
    headlinevariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h1+' | 'h2+' | 'h3s'
  }
};

export default function NvisoPageIntro({
  data: {
    style, label, title, content, callToActions, headlinevariant
  },
}: Props) {
  const { enableLines } = useContext(LinesContext);
  const callToActionObjects = useCallToActions(callToActions ?? [], false);

  return (
    <PageIntro
      enableLines={enableLines}
      variant={style}
      label={label}
      title={title}
      content={content ? parseHtml(content) : undefined}
      callToActions={callToActionObjects}
      headlinevariant={headlinevariant}
    />
  );
}
